export default id => (dispatch, getState) => {
	const state = getState()
	let new_alerts = state.alerts.filter(_alert => id !== _alert.id)
	dispatch({
		type: 'MODIFY_ALERTS',
		payload: new_alerts
	})
}
